window.jQuery = window.$ = require('jquery');
require('foundation-sites');
var Swiper = require('swiper');

import './_tabs.js';

$(function(){

	// add foundation
	$(document).foundation();

	if(!!Swiper && $('.swiper-container').length ){
	// swiper
	my_swiper = new Swiper('.swiper-container', {
		speed: 500,
		pagination: {
      el: '.swiper-pagination',
			clickable: true,
    },
		slidesPerView: 'auto',
		loop: true,
		paginationClickable:true,
	});
	}

	$('.hamburger').on('click',function(){
			$(this).toggleClass('open');
			$('#footmenu').toggleClass('open');
		});

	$('#hov_menu').on('click',function(){
		$(this).toggleClass('open');
		$('.side-menu').toggleClass('open');
	});

});
